import CustomComponent from '../CustomComponent';

import { cssObj2DomObj, transformPx2Rem, convertStyleData } from '@utils/tools';
import { customEvent } from '@utils/customEvent';

import './LayoutVesselCustomComponent.less';

export default function LayoutVesselCustomComponent(props) {
  /**
   * 传入数据
   */ 
  const data = props.data;                // 组件数据
  const detailData = props.detailData;    // 详情页数据
  const dynamicData = props.dynamicData;  // 动态数据
  /**
   * 样式数据处理
   */
  const styleObj = convertStyleData(props.data.style);
  /**
   * 组件特性数据处理
   */
  const customFeature = cssObj2DomObj(props.data.customFeature);
  const leftStyleObj = {
    width: customFeature.cellWidth + '%',
  }
  const rightStyleObj = {
    width: 100 - customFeature.cellWidth + '%',
    borderLeftStyle: customFeature.CellBorderStyle,
    borderLeftWidth: transformPx2Rem(customFeature.CellBorderWidth,320),
    borderLeftColor: customFeature.CellBorderColor
  }
  /**
   * 组件内容处理
   */   
  let content = data.content;
  /**
   * 返回组件
   */ 
  return (
    <div className="custom-component layout-vessel" style={styleObj} onClick={() => customEvent({customFeature})}>
      <div className="left-eles" style={leftStyleObj}>
        {content.leftEles.map((componentData, componentIndex) => 
          <CustomComponent key={componentIndex} index={componentIndex} data={componentData} detailData={detailData} dynamicData={dynamicData}/>
        )}
      </div>
      <div className="left-eles" style={rightStyleObj}>
        {content.rightEles.map((componentData, componentIndex) => 
          <CustomComponent key={componentIndex} index={componentIndex} data={componentData} detailData={detailData} dynamicData={dynamicData}/>
        )}
        </div>
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/custom-component/layout-vessel-custom-component/LayoutVesselCustomComponent.jsx